import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";

var _createReducer;

import { createReducer } from 'redux-act';
import { setCurrentId, setPersonalId } from './actions';
import sharingResource from './resource';
export var initialState = {
  personal: undefined,
  current: undefined,
  organizations: {},
  filteredOrganizations: {}
}; // ********** HANDLERS **********

export var fetchHandler = function fetchHandler(state, _ref) {
  var response = _ref.response,
      label = _ref.label,
      accumulate = _ref.accumulate;

  if (label) {
    return _objectSpread(_objectSpread({}, state), {}, {
      filteredOrganizations: response.data.reduce(function (old, current) {
        return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, current.id, current));
      }, accumulate ? state.filteredOrganizations : {})
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    organizations: response.data.reduce(function (old, current) {
      return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, current.id, _objectSpread(_objectSpread({}, state.organizations[current.id] || {}), current)));
    }, accumulate ? state.organizations : {})
  });
};
export var fetchOneHandler = function fetchOneHandler(state, _ref2) {
  var response = _ref2.response,
      label = _ref2.label;
  return _objectSpread(_objectSpread({}, state), {}, {
    organizations: _objectSpread(_objectSpread({}, state.organizations), {}, _defineProperty({}, label, _objectSpread(_objectSpread({}, state.organizations[label] || {}), response.data)))
  });
};
export var setCurrentHandler = function setCurrentHandler(state, id) {
  return _objectSpread(_objectSpread({}, state), {}, {
    current: id
  });
};
export var setPersonalHandler = function setPersonalHandler(state, id) {
  return _objectSpread(_objectSpread({}, state), {}, {
    personal: id
  });
}; // ********** REDUCER **********

var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, sharingResource.fetch.success.getType(), fetchHandler), _defineProperty(_createReducer, sharingResource.fetchOne.success.getType(), fetchOneHandler), _defineProperty(_createReducer, setCurrentId, setCurrentHandler), _defineProperty(_createReducer, setPersonalId, setPersonalHandler), _createReducer), initialState);
export default reducer;